import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain'
import { Spin, Row, Input, Button, Popconfirm, Divider, Table, message, Drawer, Badge } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
// import SourceClassifierDetail from './source_classifier_detail';
import { showErrorInNotification, formatMoney } from '../../../lib/util';
import PipelineClassifierExtractors from './pipeline_classifier_extractors';
import Title from 'antd/lib/typography/Title';

const classifiers_cols = ({ props, onEditPressed, onDeletePressed, onViewPressed, onExtractorPressed }) => [
  // {
  //   title: 'Field Name',
  //   dataIndex: 'field'
  // },
  {
    title: 'Expression',
    dataIndex: 'expression',
    className:'word-break'
  },
  {
    title: 'Service',
    dataIndex: 'service_id',
    render: (service_id, data) => {
      let service = (data.__references__ && data.__references__.service_id) || {};
      return <Badge color={service.color_code} text={service.name}/>
    }
  },
  {
    title: 'Enricher',
    dataIndex: 'enricher_id',
    // render: (enricher_id, data) => {
    //   let enricher = (data.__references__ && data.__references__.enricher_id) || {};
    //   return enricher.name
    // }
  },
 
  {
    title: 'Order',
    dataIndex: 'order'
  },
  {
    title: 'Action',

    render: (data) => <span>
      {/* <Button type='link' style={{ padding: 0 }} onClick={() => {
          typeof onViewPressed === 'function' && onViewPressed(data)
      }}>View</Button>
          <Divider type="vertical" /> */}

      <Button type='link' style={{ padding: 0 }} onClick={() => {
        typeof onExtractorPressed === 'function' && onExtractorPressed(data)
      }}>Extractors</Button>
      <Divider type="vertical" />
      <Button type='link' style={{ padding: 0 }} onClick={() => {
        typeof onEditPressed === 'function' && onEditPressed(data)
      }}>Edit</Button>
      <Divider type="vertical" />
      <Popconfirm title="Are you sure you want to delete?" onConfirm={() => {
        typeof onDeletePressed === 'function' && onDeletePressed(data.id)

      }}>
        <Button type='link' style={{ color: 'red', padding: 0 }}>Delete</Button></Popconfirm>  </span>
  }
];
const classifiers_fields = [
  {
    name: 'Field Name',
    index: 'field',
    type: 'select',
    filterable: true,
    options: []
  },
  {
    name: 'Expression',
    index: 'expression',
    type: 'text',
  
  },
  {
    name: 'Service',
    index: 'service_id',
    filterable: true,
    type: 'select',
    options: []
  },
  {
    name: 'Enricher',
    index: 'enricher_id',
    filterable: true,
    type: 'select',
    options: []
  },
 
  {
    name: 'Order',
    index: 'order',
    type: 'text'
  },
  {index:'flags',name:"Flag",type:'networkselect',url:`/data-types/null/flags`,mode:'multiple'}
];





class PipelineClassifier extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pipeline_data: this.props.pipeline_data,
      schema: classifiers_fields,
      form_data: {},
      edit_id: null,
      modal_open: false,
      detail_drawer_visibility: false,
      extractor_drawer_visibility: false,
      current_rule_id: null
    };

    this.pipeline_id = this.props.pipeline_id;
    this.datatype_id=this.props.datatype_id;

    this.fieldOptionAssigner(this.props.pipeline_data)

    this.has_changed = false;

    this.list_classifiers = RESTExecutor.list().config({
      label: 'pipeline_classifiers'
    }).forId(this.props.pipeline_id).connect(props.domains.datatype);

    this.post_classifiers = RESTExecutor.post().config({
      label: 'pipeline_classifiers'
    }).forId("").callbacks((success) => {
      this.list_classifiers.execute();
      this.setState({ modal_open: false })
    })
      .callbacks((success) => {
        this.setState({
          form_data: {},
          edit_id: null,
          modal_open: false,
        })
        this.list_classifiers.execute()
       }, (error) => {

        // showErrorInNotification(error)
      })
      .connect(props.domains.datatype);

    this.patch_classifiers = RESTExecutor.patch().config({
      label: 'pipeline_classifiers_detail',
      params: {
        pipeline_id: this.pipeline_id,
        classifier_id: ""
      }
    }).callbacks((success) => {
      this.setState({
        form_data: {},
        edit_id: null,
        modal_open: false,
      })
      this.list_classifiers.execute()
    }).connect(props.domains.datatype);


    this.list_enrichers = RESTExecutor.list().config({
      label: 'enrichers',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
      let enricher_options = [];
      let schema = this.state.schema;

      success.result.rows.map((item) => {
        enricher_options.push({
          text: item.id,
          value: item.id
        })
      });

      schema.map((item) => {
        if (item.index === 'enricher_id') {
          item['options'] = enricher_options
        }
        if(item.index==='flags'){
          item['url']=`/data-types/${this.datatype_id}/flags`
        }
      });

      this.setState({
        schema: schema
      })
    }).connect(props.domains.settings);


    this.list_services = RESTExecutor.list().config({
      label: 'services_list',
      params: {
        pagination: false
      }
    }).forId(this.datatype_id)
      .callbacks((success) => {
        let service_options = [];
        let schema = this.state.schema;

        success.result.rows.map((item) => {
          service_options.push({
            render: (value) => <div
              name={value}
              style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center'
              }}>
              <div style={{ height: 12, width: 12, borderRadius: 6, marginRight: 10, backgroundColor: item.color_code }}></div>

              <span>{item.name}</span>
            </div>,
            text: item.name,
            value: item.id
          })
        });

        schema.map((item) => {
          if (item.index === 'service_id') {
            item['options'] = service_options
          }
        });

        this.setState({
          schema: schema
        })
      },(error)=>{
        showErrorInNotification(error);
      })
      .connect(props.domains.datatype);


    if (this.props.pipeline_id) {
      this.list_classifiers.forId(this.props.pipeline_id).execute();
    }

    this.list_services.execute();
    this.list_enrichers.execute()
  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  deleteRules = (id) => {

    RESTExecutor.delete().config({
      label: 'pipeline_classifiers_detail',
      params: {
        pipeline_id: this.pipeline_id,
        classifier_id: id
      }
    }).callbacks((success) => {
      this.list_classifiers.execute();
    }, (error) => {
      message.error("Failed to delete Service rules. Please try again.")
    }).connect(this.props.domains.datatype).execute()
  }



  handlePostPatch = (data) => {

    if (this.state.edit_id) {
      // patch
      this.patch_classifiers.config({
        params: {
          pipeline_id: this.pipeline_id,
          classifier_id: this.state.edit_id
        }
      }).execute(data);
    } else {
      this.post_classifiers.forId(this.pipeline_id).execute(data);
    }

  }

  render() {

    if (!this.props.pipeline_id) {
      return <Spin />
    }

    const { pipeline_data, schema, modal_open, edit_id, form_data } = this.state;

    let list_classifiers_resp = this.list_classifiers.response();
    let list_classifiers_data = list_classifiers_resp.result || {};

    let post_classifiers_resp = this.post_classifiers.response();
    let patch_classifiers_resp = this.patch_classifiers.response();

    let rowsData = list_classifiers_data.rows || [];
    let rowsMeta = list_classifiers_resp.meta || {};
    return (
      <div>
        <PopUpForm
          title="Classifier"
          width="50%"
          forCreate={this.state.edit_id
            ? false
            : true}
          initialData={form_data}
          fields={this.state.schema}
          open={modal_open}
          networkState={this.state.edit_id ? patch_classifiers_resp : post_classifiers_resp}
          onClose={() => this.setState({ modal_open: false })}
          onSubmit={(data) => {
            // console.log("DATA", data);
            this.handlePostPatch(data)
            // this.post_rules.execute(data);
          }}
        />
        <Table
        scroll={{x:true}}
          className='main-table '
          loading={list_classifiers_resp.fetching}
          size='small'

          pagination={{
            simple: false,
                    position:'bottom',
            onChange: (current, size) => {
              this.list_classifiers.config({
                params: {
                  per_page: size,
                  page: current
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
          }}
          // bordered={false}
          title={() => <Row type='flex' justify='space-between' style={{
            alignItems: 'center'
          }}><Title style={{
            margin: 0
          }}
            level={4}
          >Classifier</Title>
            <Button type='primary' onClick={() => {
              this.setState({
                edit_id: null,
                form_data: {},
                modal_open: true
              })
            }}>
              Add New
                </Button>
          </Row>}
          rowKey={(record) => record.id}
          columns={classifiers_cols({
            onEditPressed: (data) => {
              this.setState({
                edit_id: data.id,
                form_data: data,
                modal_open: true
              })
            },

            onDeletePressed: this.deleteRules,
            onViewPressed: (data) => {
              this.setState({
                detail_drawer_visibility: true,
                current_rule_id: data.id
              })
            },
            onExtractorPressed: (data) => {
              this.setState({
                extractor_drawer_visibility: true,
                current_rule_id: data.id
              })
            }
          })}
          dataSource={rowsData}
        />

 <Drawer 
            title={<Title style={{margin:0}}>Extractors</Title>}
            placement="right"
            closable={false}
            width='70%'
            destroyOnClose
            onClose={() => {
                this.setState({
                    extractor_drawer_visibility: false,
                    current_rule_id:null
                })
            }}
            visible={this.state.extractor_drawer_visibility}
            >
                <PipelineClassifierExtractors
                onClose={() => {
                    this.setState({
                        extractor_drawer_visibility: false,
                        current_rule_id:null
                    })
                }}
                pipeline_id={this.pipeline_id}
                classifier_id={this.state.current_rule_id}
                pipeline_data={this.state.pipeline_data}
                />
            </Drawer>

      </div>
    );
  }



  fieldOptionAssigner = (data = {}) => {
    // field name option assigner
    let configs = (data.parse_config && data.parse_config.config) || [];
    let extra_configs = (data.parse_config && data.parse_config.extra_fields) || [];
    // console.log("CHECK",configs,extra_configs)
    let config_array = configs.concat(extra_configs);

    let schema = this.state.schema;
    let col_options = []

    config_array.map((configObj) => {
      // Object.keys(configObj).map((key) => {
        let config_item = configObj;
        // console.log("config item", config_item)

        if (config_item.validation.type === 'string') {
          col_options.push({
            text: config_item.name,
            value: config_item.name
          });
        }
      // })

    })
    // console.log("option assigned",col_options)

    schema.map((item) => {
      if (item.index === 'field') {
        item['options'] = col_options
      }
    });
    this.setState({
      schema: schema
    })
  }
}

export default withDomains(PipelineClassifier, "settings", "datatype");
